module.exports = __webpack_public_path__ + "static/media/section1.2aeced5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/section1.jpg
// module id = 29
// module chunks = 0